function Unidades(_num) {
  switch (_num) {
    case 1: return 'UNO';
    case 2: return 'DOS';
    case 3: return 'TRES';
    case 4: return 'CUATRO';
    case 5: return 'CINCO';
    case 6: return 'SEIS';
    case 7: return 'SIETE';
    case 8: return 'OCHO';
    case 9: return 'NUEVE';
    default: return '';
  }
}

function DecenasY(strSin, numUnidades) {
  return numUnidades > 0 ? `${strSin } Y ${ Unidades(numUnidades)}` : strSin;
}

function Decenas(_num) {
  const decena = Math.floor(_num / 10);
  const unidad = _num % 10;

  switch (decena) {
    case 1:
      switch (unidad) {
        case 0: return 'DIEZ';
        case 1: return 'ONCE';
        case 2: return 'DOCE';
        case 3: return 'TRECE';
        case 4: return 'CATORCE';
        case 5: return 'QUINCE';
        default: return `DIECI${ Unidades(unidad)}`;
      }
    case 2:
      return unidad === 0 ? 'VEINTE' : `VEINTI${ Unidades(unidad)}`;
    case 3: return DecenasY('TREINTA', unidad);
    case 4: return DecenasY('CUARENTA', unidad);
    case 5: return DecenasY('CINCUENTA', unidad);
    case 6: return DecenasY('SESENTA', unidad);
    case 7: return DecenasY('SETENTA', unidad);
    case 8: return DecenasY('OCHENTA', unidad);
    case 9: return DecenasY('NOVENTA', unidad);
    default: return Unidades(unidad);
  }
}

function Centenas(_num) {
  const centenas = Math.floor(_num / 100);
  const decenas = _num % 100;

  switch (centenas) {
    case 1: return decenas > 0 ? `CIENTO ${ Decenas(decenas)}` : 'CIEN';
    case 2: return `DOSCIENTOS ${ Decenas(decenas)}`;
    case 3: return `TRESCIENTOS ${ Decenas(decenas)}`;
    case 4: return `CUATROCIENTOS ${ Decenas(decenas)}`;
    case 5: return `QUINIENTOS ${ Decenas(decenas)}`;
    case 6: return `SEISCIENTOS ${ Decenas(decenas)}`;
    case 7: return `SETECIENTOS ${ Decenas(decenas)}`;
    case 8: return `OCHOCIENTOS ${ Decenas(decenas)}`;
    case 9: return `NOVECIENTOS ${ Decenas(decenas)}`;
    default: return Decenas(decenas);
  }
}

function Miles(_num) {
  if (_num === 0) return '';

  const divisor = 1000;
  const cientos = Math.floor(_num / divisor);
  const resto = _num % divisor;

  // eslint-disable-next-line no-nested-ternary
  const strMiles = cientos > 1 ? `${Centenas(cientos)} MIL` : cientos === 1 ? 'MIL' : '';
  const strCentenas = Centenas(resto);

  return `${strMiles} ${strCentenas}`.trim();
}

function Millones(_num) {
  const divisor = 1000000;
  const cientos = Math.floor(_num / divisor);
  const resto = _num % divisor;

  // eslint-disable-next-line no-nested-ternary
  const strMillones = cientos > 1 ? `${Centenas(cientos)} MILLONES` : cientos === 1 ? 'UN MILLON' : '';
  const strMiles = Miles(resto);

  return `${strMillones} ${strMiles}`.trim();
}

export function numToWords(num) {
  if (num === 0) return 'CERO';
  return Millones(num).trim();
}
